import axios, { InternalAxiosRequestConfig } from 'axios';
import API_CONFIG from './api';

// Configurar axios com URL base (sem /api/v1 pois já está nas chamadas)
import { getBackendBaseUrl } from './environment';

axios.defaults.baseURL = getBackendBaseUrl();
axios.defaults.timeout = API_CONFIG.TIMEOUT;
axios.defaults.headers.common['Content-Type'] = API_CONFIG.HEADERS['Content-Type'];

// Interceptor para requisições - autenticação + contexto de unidade (multi-unidade)
axios.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // FormData precisa sem Content-Type fixo: o browser define multipart + boundary.
    // O default application/json quebra upload (OFX, avatar, etc.) — multer recebe corpo vazio.
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      const h = config.headers;
      if (h && typeof (h as any).delete === 'function') {
        (h as any).delete('Content-Type');
      } else if (h) {
        delete (h as Record<string, unknown>)['Content-Type'];
      }
    }

    // Adicionar token de autenticação se disponível
    const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Anexar X-Unit-Id automaticamente quando houver unidade ativa.
    // O backend usa esse header como override do JWT em rotas protegidas
    // por requireUnitScope (apenas se o usuário pertencer à unidade).
    if (!config.headers['X-Unit-Id']) {
      try {
        const rawUser = localStorage.getItem('auth_user');
        if (rawUser) {
          const parsed = JSON.parse(rawUser);
          const unitId = parsed?.current_unit?.id;
          if (unitId) config.headers['X-Unit-Id'] = unitId;
        }
      } catch (_e) {
        // ignore JSON parse errors
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para respostas - apenas tratar erros de autenticação
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Tratar erros de autenticação
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axios; 